import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const TabsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: Baloo Da;
  border: 1px solid ${({ theme }) => theme.bsBorder2};
  width: 248px;
  flex: 1 1 auto;
  box-sizing: border-box;
  border-radius: 50px;
  margin-top: 64px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
    margin: auto;
    margin-top: 64px;
  `}
`
const activeclass = 'ACTIVENAV'

const TabItem = styled.div.attrs({
  activeclass
})`
  cursor: pointer;
  position: relative;
  color: ${({ theme }) => theme.bsText22};
  font-family: Roboto, 'Libre Franklin', 'Roboto-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;
  white-space:nowrap;
  text-align: center;
  letter-spacing: 0.02em;
  width: 124px;
  height: 38px;
  line-height: 38px;

  &.${activeclass} {
    background: linear-gradient(285.72deg, #FFD600 -21.15%, #FF7A00 60.61%);
    border-radius: 50px;
    width: 124px;
    color: #FFFFFF;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
    &.${activeclass} {
      font-size: 14px;
    }
  `};
`

export default function Tabs({owner, curTab, USER}: { owner: string, curTab: string, USER: any }) {
  const history = useHistory()
  const toggleTab = (tab: string) => {
    history.push(`/usercenter/${owner}?type=${tab}`)
  }

  return (
    <TabsWrapper>
      <TabItem onClick={toggleTab.bind(null, USER.CREATED)} className={curTab === USER.CREATED ? activeclass : ''}>Created</TabItem>
      <TabItem onClick={toggleTab.bind(null, USER.COLLECTED)} className={curTab === USER.COLLECTED ? activeclass : ''}>Collected</TabItem>
    </TabsWrapper>
  )
}
